import { createBrowserRouter } from 'react-router';
import { LoginChooser } from '@/features/auth/LoginChooser';
import { LoginPage } from '@/features/auth/LoginPage';
import { InternalLayout } from '@/features/internal/InternalLayout';
import { internalRoutes } from '@/features/internal/routes';
import { OwnerLayout } from '@/features/owner/OwnerLayout';
import { ownerRoutes } from '@/features/owner/routes';
import { TenantLayout } from '@/features/tenant/TenantLayout';
import { tenantRoutes } from '@/features/tenant/routes';
import { NotFoundPage, RootRedirect, RouteError } from './system-pages';

/**
 * Three apps, one client. Which one you see is decided by your role at sign-in:
 *   /app       property owners, managers and their staff
 *   /tenant    residents
 *   /internal  the MOVO team
 */
export const router = createBrowserRouter([
  { path: '/', element: <RootRedirect /> },
  { path: '/login', element: <LoginChooser /> },
  { path: '/login/owner', element: <LoginPage audience="owner" /> },
  { path: '/login/tenant', element: <LoginPage audience="tenant" /> },
  { path: '/login/team', element: <LoginPage audience="internal" /> },
  { path: '/app', element: <OwnerLayout />, errorElement: <RouteError />, children: ownerRoutes },
  { path: '/tenant', element: <TenantLayout />, errorElement: <RouteError />, children: tenantRoutes },
  { path: '/internal', element: <InternalLayout />, errorElement: <RouteError />, children: internalRoutes },
  { path: '*', element: <NotFoundPage /> },
]);
